import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { ObjectType, ModuleStreamingChartEdges } from '@/@types/graphql-types';

import TitleDetailStreamingChartListItem from '@/components/details/streaming-chart/TitleDetailStreamingChartListItem.vue';
import { streamingChartLandingPageCountries } from '@/components/details/streaming-chart/streaming-chart-config';

import { timestamp } from '@/helpers/date-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleDetailStreamingChartListV2',
  props: {
    titles: null,
    titleObjectType: null,
    lastUpdated: null,
    titleId: { default: '' },
    isSidebar: { type: Boolean, default: false }
  },
  emits: ["clicked"],
  setup(__props: any, { emit: emits }: { emit: ({
	(
		e: 'clicked',
		data: {
			title: ModuleStreamingChartEdges;
			index: number;
		}
	): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { titles: ModuleStreamingChartEdges[], titleObjectType: ObjectType | undefined, lastUpdated: string | number | Date, titleId: string, isSidebar: boolean };





const { language, country } = useLanguageStore();

const showChart = computed(() => props.titles?.length > 0);

const updatedTimestamp = computed(() => {
	const updated = timestamp(
		props.lastUpdated,
		{
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
		},
		country.value,
		language.value
	);

	return `${updated.time}, ${updated.date}`;
});

const showLinkButton = computed(
	() => !!streamingChartLandingPageCountries.includes(country.value) && language.value === 'en'
);

const linkButtonText = computed(() => {
	if (props.titleObjectType === ObjectType.Movie) return 'Show all movies in the JustWatch Streaming Charts';
	if (props.titleObjectType === ObjectType.Show) return 'Show all TV shows in the JustWatch Streaming Charts';
	if (props.titleObjectType === ObjectType.ShowSeason) return 'Show all seasons in the JustWatch Streaming Charts';
	return 'Show all titles in the JustWatch Streaming Charts';
});

const linkButtonQueryParams = computed(() => {
	let objectTypeQueryParam = undefined;
	if (props.titleObjectType === ObjectType.Show) objectTypeQueryParam = 'shows';
	if (props.titleObjectType === ObjectType.ShowSeason) objectTypeQueryParam = 'seasons';

	return {
		t: objectTypeQueryParam,
		ct: 'daily',
	};
});

function onClick(title: ModuleStreamingChartEdges, index: number) {
	emits('clicked', { title, index });
}

function getTitle(title: ModuleStreamingChartEdges) {
	return title?.showTitle || title?.title;
}

function getSeason(title: ModuleStreamingChartEdges) {
	return title?.seasonNumber;
}

function getChartPosition(title: ModuleStreamingChartEdges) {
	return title?.rankInfo?.rank;
}

function getChartPositionDynamic(title: ModuleStreamingChartEdges) {
	return title?.rankInfo?.trend;
}

function getChartMovement(title: ModuleStreamingChartEdges) {
	return title?.rankInfo?.trendDifference;
}

function getDaysInTop1000(title: ModuleStreamingChartEdges) {
	return title.rankInfo?.daysInTop1000;
}

function isTitle(title: ModuleStreamingChartEdges) {
	return title?.jwEntityID === props.titleId;
}

function trackLinkClick() {
	TrackingHelper.trackEvent('userinteraction', {
		action: 'redirect_clicked',
		label: 'streaming_chart',
	});
}

return { __sfc: true,props, emits, language, country, showChart, updatedTimestamp, showLinkButton, linkButtonText, linkButtonQueryParams, onClick, getTitle, getSeason, getChartPosition, getChartPositionDynamic, getChartMovement, getDaysInTop1000, isTitle, trackLinkClick, TitleDetailStreamingChartListItem }
}

})